// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"1a68166e","189":"604db830","254":"97b0d2b7","281":"2d1cbaeb","425":"6a70a9b6","444":"7562d2ad","447":"64e4257a","568":"2ecc5377","845":"c42cbd72","885":"23770074"}[chunkId] + ".chunk.js";
};